import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getTransferDriverList as getTransferDriverListApi,
	getTransferDriver as getTransferDriverApi,
	addNewTransferDriver as addNewTransferDriverApi,
	updateTransferDriver as updateTransferDriverApi,
	deleteTransferDriver as deleteTransferDriverApi,
} from '../../helpers/transfer/backend_helper';

export const getTransferDriverList = createAsyncThunk('transferDrivers/getTransferDriverList', async () => {
	try {
		const response = getTransferDriverListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getTransferDriver = createAsyncThunk('transferDrivers/getTransferDriver', async transferDriver_id => {
	try {
		const response = getTransferDriverApi(transferDriver_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewTransferDriver = createAsyncThunk('transferDrivers/addNewTransferDriver', async transferDriver => {
	try {
		const response = addNewTransferDriverApi(transferDriver);
		toast.success('TransferDriver agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar transferDriver.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateTransferDriver = createAsyncThunk('transferDrivers/updateTransferDriver', async (transferDriver) => {
		try {
			const response = updateTransferDriverApi(transferDriver);
			toast.success('TransferDriver actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar transferDriver.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteTransferDriver = createAsyncThunk('transferDrivers/deleteTransferDriver', async transferDriver => {
	try {
		const response = await deleteTransferDriverApi(transferDriver);
		toast.success('TransferDriver eliminado exitosamente.', { autoClose: 3000 });
		return { transferDriver, ...response };
	} catch (error) {
		toast.error('Error al eliminar transferDriver.', { autoClose: 3000 });
		throw new Error(error);
	}
});
